// Generated by scripts/ui/sync_auth_transition.py; edit shared/auth/browser_transition.js.
// Canonical presentation only. Authentication and destinations belong to the caller.
(() => {
  if (typeof window === "undefined" || window.turnusAuthTransition) return;
  const DEFAULT_DELAY_MS = 1000;
  const icons = {
    JobHub: '<rect x="3" y="3" width="7" height="7" rx="2"/><rect x="14" y="14" width="7" height="7" rx="2"/><path d="M6 10v7h8"/>',
    CalendarHub: '<rect x="3" y="5" width="18" height="16" rx="2"/><path d="M7 3v4m10-4v4M3 11h18"/>',
    LSMHub: '<path d="M12 3 3 7v6c0 5 9 8 9 8s9-3 9-8V7z"/>',
    PaymentHub: '<rect x="3" y="5" width="18" height="14" rx="2"/><path d="M3 10h18m-13 5h3"/>',
    CatalogHub: '<path d="m12 3 9 5v8l-9 5-9-5V8zm0 9v9M3 8l9 4 9-4"/>',
    MemoHub: '<path d="m3 3 18 6-7 5-5 7zm6 18 5-7L3 3"/>',
    BelegHub: '<path d="M6 3h8l4 4v14H6zm8 0v5h4M9 12h6m-6 4h6"/>',
    TicketHub: '<path d="M3 5h18v5a2 2 0 0 0 0 4v5H3v-5a2 2 0 0 0 0-4zM15 5v3m0 3v2m0 3v3"/>',
    AgentsHub: '<circle cx="9" cy="7" r="3"/><path d="M3 21v-4a6 6 0 0 1 12 0v4m2-17a3 3 0 0 1 0 6m1 4a5 5 0 0 1 3 4v3"/>',
    DataHubClient: '<path d="M3 13h18M5 13l2-8h10l2 8"/><circle cx="7" cy="18" r="3"/><circle cx="17" cy="18" r="3"/><path d="M10 18h4"/>',
    mmlHub: '<path d="M4 20V9m8 11V4m8 16v-7M2 20h20"/>',
  };
  let root, timer, current, navigating = false, previousFocus;
  let logoutMode = false;
  let generation = 0, readyObserver;
  let background = [];
  // Navigation continuity only; this marker grants no authentication or access.
  const routeKey = (appName) => `turnus.idhub.route.${appName}`;
  const routeLocation = () => `${window.location.pathname}${window.location.search}`;
  const clearTimer = () => { window.clearTimeout(timer); timer = undefined; };
  const cancel = () => {
    clearTimer();
    generation += 1;
    readyObserver?.disconnect(); readyObserver = undefined;
    logoutMode = false;
    root?.remove(); root = undefined; current = undefined; navigating = false;
    for (const [node, inert] of background) node.inert = inert;
    background = [];
    if (previousFocus?.isConnected) previousFocus.focus();
    previousFocus = undefined;
  };
  const proceed = () => {
    if (!current || navigating || current.loading || current.blocked) return;
    clearTimer(); navigating = true;
    const options = current;
    const startedGeneration = generation;
    root.querySelector("button").disabled = true;
    root.querySelector("p").lastChild.textContent = `Weiterleitung zu ${options.targetName || options.appName} läuft …`;
    try {
      window.sessionStorage.setItem(routeKey(options.appName), JSON.stringify({returnTo: routeLocation(), startedAt: Date.now()}));
      Promise.resolve(options.navigate()).then((result) => {
        if (result?.ok === false) throw new Error(result.detail || "Weiterleitung fehlgeschlagen.");
      }).catch((error) => {
        if (startedGeneration !== generation || logoutMode) return;
        window.sessionStorage.removeItem(routeKey(options.appName));
        cancel(); options.onError?.(error);
      });
    } catch (error) {
      if (startedGeneration !== generation || logoutMode) return;
      window.sessionStorage.removeItem(routeKey(options.appName)); cancel(); options.onError?.(error);
    }
  };
  const show = (options) => {
    if (logoutMode) return () => {};
    const sameTransition = current?.appName === options.appName && root?.isConnected;
    const samePhase = sameTransition && Boolean(current.checking) === Boolean(options.checking);
    if (!sameTransition) cancel();
    current = options;
    if (!root) {
      root = document.createElement("div");
      root.className = "turnus-auth-transition";
      root.innerHTML = `<section class="turnus-auth-card" role="dialog" tabindex="-1" aria-modal="true" aria-label="Weiterleitung zur Anwendung">
        <header><span class="turnus-auth-icon" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">${icons[options.appName] || '<rect x="3" y="3" width="18" height="18" rx="2"/><path d="M8 8h8m-8 4h8m-8 4h5"/>'}</svg></span><strong></strong></header>
        <p role="status" aria-live="polite"><span class="turnus-auth-progress" aria-hidden="true"></span>Weiterleitung …</p>
        <footer><button type="button">Jetzt weiter … <span aria-hidden="true">→</span></button></footer>
      </section>`;
      root.querySelector("button").addEventListener("click", proceed);
    }
    root.querySelector("strong").textContent = options.appName;
    const destination = options.targetName || options.appName;
    root.querySelector("p").lastChild.textContent = navigating ? `Weiterleitung zu ${destination} läuft …` : options.loading ? `${destination} wird geladen …` : options.checking ? `Anmeldung für ${destination} wird geprüft …` : `Weiterleitung zu ${destination} wird vorbereitet …`;
    const button = root.querySelector("button");
    const buttonHadFocus = document.activeElement === button;
    button.disabled = Boolean(options.loading || options.blocked) || navigating;
    if (button.disabled && buttonHadFocus) root.querySelector("section").focus();
    if (!document.getElementById("turnus-auth-transition-style")) {
      const style = document.createElement("style"); style.id = "turnus-auth-transition-style";
      style.textContent = `
        .turnus-auth-transition{position:fixed;inset:0;z-index:2147483000;display:flex;align-items:flex-start;justify-content:center;padding:max(20vh,7rem) 1rem 1rem;box-sizing:border-box;background:#f3f1ed;color:#202124;font:14px/1.45 "IBM Plex Sans",system-ui,sans-serif}
        .turnus-auth-card{outline:none;box-sizing:border-box;width:min(22rem,100%);height:196px;padding:22px;display:grid;grid-template-rows:32px minmax(40px,1fr)32px;gap:12px;background:#fbfbfa;border:1px solid #d9d7d2;border-radius:8px;box-shadow:0 8px 24px #2021240a}
        .turnus-auth-card header{display:flex;align-items:center;gap:12px}.turnus-auth-card strong{text-align:left;font-size:16px;font-weight:650}.turnus-auth-icon{width:32px;height:32px;display:grid;place-items:center;border:1px solid #d9d7d2;border-radius:5px}.turnus-auth-icon svg{width:20px;height:20px}
        .turnus-auth-card p{text-align:center;display:flex;justify-content:center;align-items:center;gap:8px;margin:0;font-size:13px;color:#666860}.turnus-auth-card footer{display:flex;justify-content:flex-end;align-items:flex-end;margin-top:0}
        .turnus-auth-card button{appearance:none;display:flex;align-items:center;gap:16px;height:32px;padding:0 12px;border:1px solid #202124;border-radius:5px;background:#202124;color:#fff;font:600 13px/1 system-ui,sans-serif;cursor:pointer;box-shadow:none;outline:none}.turnus-auth-card button:hover{background:#353638}.turnus-auth-card button:focus-visible{border-color:#7184ac}.turnus-auth-card button:disabled{opacity:.6;cursor:progress}
        .turnus-auth-progress{flex-shrink:0;width:10px;height:10px;border:1px solid #d9d7d2;border-top-color:#666860;border-radius:50%;animation:turnus-auth-spin 1s linear infinite}@keyframes turnus-auth-spin{to{transform:rotate(360deg)}}@media(prefers-reduced-motion:reduce){.turnus-auth-progress{animation:none}}
      `;
      document.head.append(style);
    }
    if (!sameTransition) {
      previousFocus = document.activeElement;
      background = Array.from(document.body.children).map((node) => [node, node.inert]);
      for (const [node] of background) node.inert = true;
      document.body.append(root);
      (button.disabled ? root.querySelector("section") : button).focus();
    }
    const delay = options.delayMs ?? DEFAULT_DELAY_MS;
    if (!Number.isFinite(delay) || delay < 0) { cancel(); throw new Error("Ungültige Anzeigedauer."); }
    if (!samePhase) clearTimer();
    if (!options.checking && !navigating && !timer) timer = window.setTimeout(proceed, delay);
    return cancel;
  };
  const enter = (options) => {
    const key = routeKey(options.appName);
    const raw = window.sessionStorage.getItem(key);
    window.sessionStorage.removeItem(key);
    let previous;
    try { previous = raw ? JSON.parse(raw) : null; } catch { previous = null; }
    const returned = previous?.returnTo === routeLocation() && Date.now() - previous.startedAt < 300000;
    if (options.returned || (options.allowNavigationReturn && returned)) return false;
    show(options);
    return true;
  };
  // Readiness is presentation-only: callers must prove authentication and data first.
  const beginView = (options) => {
    if (logoutMode || navigating) return null;
    show({...options, checking: true, blocked: true});
    return generation;
  };
  const loading = (ticket) => {
    if (ticket !== generation || logoutMode || navigating || !current) return false;
    show({...current, checking: true, loading: true});
    return true;
  };
  const ready = (ticket, selector) => {
    if (ticket !== generation || logoutMode || navigating || !root) return false;
    const finish = () => {
      if (ticket !== generation || logoutMode || navigating) return;
      if (!document.querySelector(selector)) return;
      cancel();
    };
    readyObserver?.disconnect();
    readyObserver = new MutationObserver(finish);
    readyObserver.observe(document.body, {childList: true, subtree: true, attributes: true});
    finish();
    return true;
  };
  let logoutRequest;
  const logout = (options) => {
    if (logoutRequest) return logoutRequest;
    generation += 1;
    readyObserver?.disconnect(); readyObserver = undefined;
    clearTimer(); navigating = false;
    window.sessionStorage.removeItem(routeKey(options.appName));
    // Start revocation before clearing the caller's token/CSRF state.
    let revocation;
    try { revocation = Promise.resolve(options.revoke()); }
    catch (error) { revocation = Promise.reject(error); }
    options.clear();
    show({appName: options.appName, checking: true, navigate: () => {}});
    logoutMode = true;
    root.querySelector("p").lastChild.textContent = `Abmeldung von ${options.appName} läuft …`;
    root.querySelector("button").textContent = "Wird abgemeldet …";
    root.querySelector("button").disabled = true;
    logoutRequest = revocation.then(() => {
      options.navigate();
      return {ok: true, redirecting: true};
    }).catch((error) => {
      // An unconfirmed logout must not immediately start a new login.
      root.querySelector("p").lastChild.textContent = `Abmeldung von ${options.appName} nicht bestätigt.`;
      const button = root.querySelector("button");
      button.disabled = false; button.textContent = "Erneut abmelden";
      current = {appName: options.appName, navigate: () => logout(options)};
      options.onError?.(error);
      return {ok: false, detail: "Abmeldung konnte nicht bestätigt werden."};
    }).finally(() => { logoutRequest = undefined; });
    return logoutRequest;
  };
  window.turnusAuthTransition = { show, cancel, proceed, enter, beginView, loading, ready, logout, defaultDelayMs: DEFAULT_DELAY_MS };
})();
